import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import styles from "./ProfileForm.module.less";
import mapBackendErrors from "assets/scripts/utils/mapBackendErrors";
import Form from "../../../../common/form/Form/Form";
import ProfileNameInputs, { getErrors as getNameErrors } from "./ProfileNameInputs/ProfileNameInputs";
import ProfileAddressInputs, { getErrors as getAddressErrors } from "./ProfileAddressInputs/ProfileAddressInputs";
import ProfilePhoneInputs, { getErrors as getPhoneErrors } from "./ProfilePhoneInputs/ProfilePhoneInputs";
import ProfileOkEmailInput, { getErrors as getOkEmailErrors } from "./ProfileOkEmailInput/ProfileOkEmailInput";
function getErrors(value) {
    return {
        ...getNameErrors(value),
        ...getAddressErrors(value),
        ...getPhoneErrors(value),
        ...getOkEmailErrors(value)
    };
}
function getProfile(value) {
    return {
        ...value,
        okEmail: value.okEmail ? "yes" : "no",
        email: "",
        initialDeceased: false,
        bankAccounts: [],
        isComplete: true
    };
}
export default class ProfileEditForm extends Component {
    constructor(props, context) {
        super(props, context);
        // tslint:disable-next-line:no-shadowed-variable
        this._handleValueChange = (value) => {
            this.setState(prevState => ({
                value: {
                    ...prevState.value,
                    ...value
                }
            }));
        };
        const { profile } = props;
        this.state = {
            value: {
                firstName: profile.firstName || "",
                lastName: profile.lastName || "",
                address: profile.address || "",
                address2: profile.address2 || "",
                city: profile.city || "",
                state: profile.state || "",
                zip: profile.zip || "",
                phoneHome: profile.phoneHome || "",
                phoneCell: profile.phoneCell || "",
                phoneWork: profile.phoneWork || "",
                phoneWorkExt: profile.phoneWorkExt || "",
                preferredPhone: profile.preferredPhone || "Unspecified",
                okEmail: profile.okEmail === "yes"
            }
        };
        this._handleSubmit = this._handleSubmit.bind(this);
    }
    render() {
        const { props, state } = this;
        const { value } = state;
        const errors = getErrors(value);
        const isValid = Object.values(errors).every(it => it == null);
        const { globalError, backendErrors } = mapBackendErrors(props.fieldErrors);
        return (<Form className={props.enhancedStyles ? styles.form : undefined} isBusy={props.isLoading} isValid={isValid} onSubmit={this._handleSubmit} submitLabel={props.submitLabel} error={globalError}>
				<fieldset className="fieldset fieldset-depth-0">
					<legend>
						<span className="u-isVisuallyHidden">
							<FormattedMessage id="forms.profileEdit.legend" defaultMessage="Your Information"/>
						</span>
					</legend>

					<fieldset className={"fieldset " +
            ((process.env.CLIENT === "CapOne" && !props.isCreate && !props.children) ? "fieldset-depth-1-full-width " : "fieldset-depth-1 ") +
            "fieldset-personalInfo"}>
						<ProfileNameInputs value={value} errors={errors} backendErrors={backendErrors} onChange={this._handleValueChange}/>

						<ProfileAddressInputs value={value} errors={errors} backendErrors={backendErrors} onChange={this._handleValueChange}/>

						<ProfilePhoneInputs value={value} errors={errors} backendErrors={backendErrors} onChange={this._handleValueChange}/>
					</fieldset>

					<div className={"fieldset " +
            ((!props.isCreate && !props.children) ? "fieldset-depth-1-full-width " : "fieldset-depth-1 ") +
            "fieldset-personalInfo"}>
						{props.isCreate && <ProfileOkEmailInput deceased={props.profile.initialDeceased} value={value} errors={errors} backendErrors={backendErrors} onChange={this._handleValueChange}/>}

						{props.children}
					</div>
				</fieldset>

				{props.profile.email && props.isCreate && (<div className="text">
						<FormattedMessage id="createProfile.consent" defaultMessage="By clicking Create Profile, you consent to receive a one-time Profile Created email to {email}." values={{
            email: props.profile.email
        }} tagName="p"/>
					</div>)}
			</Form>);
    }
    _handleSubmit() {
        this.props.onSubmit(getProfile(this.state.value));
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/profile/ProfileForm/ProfileForm.tsx